// extracted by LIB_CSS_EXTRACT_LOADER
import "./scratcher_module.css"
export default {"root":"root-x61Fm1","canvas":"canvas-RvA1s5"};